var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.205 23.55C52.725 34.782 38.492 36.87 31.06 36.51c-6.503.823-21.083 1.018-27.384-4.782-7.876-7.25-.243-23.14 13.45-28.077 13.692-4.936 29.928 5.863 33.079 19.9Z",
    fill: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 51,
    height: 35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.205 23.55C52.725 34.782 38.492 36.87 31.06 36.51c-6.503.823-21.083 1.018-27.384-4.782-7.876-7.25-.243-23.14 13.45-28.077 13.692-4.936 29.928 5.863 33.079 19.9Z",
    fill: "#FBFBFB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.945 13.697c0-2.465 1.973-4.464 4.408-4.464h16.086c2.434 0 4.407 1.999 4.407 4.464V28.87c0 2.465-1.973 4.463-4.407 4.463H17.353c-2.435 0-4.408-1.998-4.408-4.463V13.697Z",
    fill: "#7A8189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.945 13.697c0-2.465 1.973-4.464 4.408-4.464h16.086c2.434 0 4.407 1.999 4.407 4.464V28.87c0 2.465-1.973 4.463-4.407 4.463H17.353c-2.435 0-4.408-1.998-4.408-4.463V13.697Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.082 20.289-2.142 2.117.506 2.991a.352.352 0 0 1-.137.341.34.34 0 0 1-.362.027l-2.649-1.412-2.648 1.412a.338.338 0 0 1-.362-.027.351.351 0 0 1-.137-.341l.506-2.99-2.143-2.118a.353.353 0 0 1-.087-.358.347.347 0 0 1 .278-.237l2.96-.436 1.325-2.721c.116-.238.5-.238.617 0l1.323 2.721 2.961.436c.13.02.238.111.278.237a.353.353 0 0 1-.087.358Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.469 8.418c0-.614.494-1.112 1.105-1.112.61 0 1.105.498 1.105 1.112v2.892c0 .614-.495 1.112-1.105 1.112s-1.105-.498-1.105-1.112V8.418Z",
    fill: "#7A8189"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.184,
    y: 7.306,
    width: 2.21,
    height: 5.117,
    rx: 1.105,
    fill: "#7A8189"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 12.945,
    y1: 10.84,
    x2: 36.971,
    y2: 37.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/event-icon.5a46459cd0270a292974ebfeb209a3df.svg";
export { ForwardRef as ReactComponent };